module.exports = __webpack_public_path__ + "static/media/banner.77813968.jpg";